import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";
import { LAB_REPORT } from "@/api_framework/api_config";

export const useUploadDocumentAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (file: File, requisition_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const formData = new FormData();
        formData.append("requisition_id", requisition_id);
        formData.append("lab_report_file", file);

        const requestOptions: RequestInit = {
          method: "POST",
          headers: {
            Authorization: `${accessToken}`,
          },
          body: formData,
          redirect: "follow",
        };

        const response = await fetch(`${LAB_REPORT?.LAB_REPORT_DOCUMENT_UPLOAD?.baseURL}`, requestOptions);

        if (response.ok) {
          const result = await response.json();
          toast.success("Image uploaded successfully");
          return { status: true, message: result?.data || "Success" };
        } else if (response.status === 413) {
          toast.error("File size is too large. Please compress and try again");
          return { status: false, message: null };
        } else {
          const errorText = await response.text();
          toast.error("Upload failed: " + errorText);
          return { status: false, message: null };
        }
      } catch (error: any) {
        captureError(error); // Custom error capturing
        toast.error("Server Error: " + error.message);
        return { status: false, message: null };
      }
    },
    [configuration, captureError],
  );

  return { execute };
};
